import React from "react";

function SectionReferencesItem(props) {
  return (
    <a
      className="references__item references__item--animation"
      title={props.title + " html reference"}
      href={props.href}
      target="_blank"
      rel="noreferrer"
    >
      <div className="references__image">
        <img src={props.src} alt="" />
      </div>
      {props.title}
    </a>
  );
}

export default SectionReferencesItem;
